// https://ckeditor.com/docs/ckeditor5/latest/api/module_core_editor_editorconfig-EditorConfig.html

export const CKEDITOR_CONFIG = {
  toolbar: [
    'heading',
    '|',
    'bold',
    'italic',
    'Blockquote',
    '|',
    'NumberedList',
    'BulletedList',
    'Outdent',
    'Indent',
    '|',
    'undo',
    'redo',
  ],
  placeholder: undefined, // Set in component
};

export const CKEDITOR_CONFIG_MIN = {
  toolbar: {
    items: [
      'bold',
      'italic',
      '|',
      'NumberedList',
      'BulletedList',
      '|',
      'Outdent',
      'Indent',
    ],
    shouldNotGroupWhenFull: true,
  },
  placeholder: undefined, // Set in component
};
